module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Bold.fb53ba77.eot";